/*
 * サブシステム名：マスタ管理
 * 機能名：ETC利用サイト編集
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'

import indexeddb from '@/ddv2.library/indexeddb'

const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdDateBox = () => import('@/components/DdDateBox')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdPasswordBox = () => import('@/components/DdPasswordBox')

export default {
  name: 'MstEtcRiyouEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    isChecked: false,
    modeOfEdit: 2,
    modeKengen: 2
  }),
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdDefaultButton,
    DdFooterButton,
    DdPasswordBox,
    DdNumericBox
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      msyssystemconfig: 'DDMasters/msysSystemConfig'
    }),
    inputType: function () {
      return this.isChecked ? 'text' : 'password'
    },
    filterSite1 () {
      const ret = indexeddb.getSystemConfig(this.currentKaishaCode, this.msyssystemconfig, 'web_url_etc_base_display')
      if (ret) {
        return ret.configValue1
      }
      return ''
    },
    filterSite2 () {
      const ret = indexeddb.getSystemConfig(this.currentKaishaCode, this.msyssystemconfig, 'web_url_etc_base_display')
      if (ret) {
        return ret.configValue2
      }
      return ''
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        return true
      }
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if ([undefined, null, '0'].includes(this.id)) {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/MstEtcRiyouJoho/find?id=${this.id}`)
          .then((data) => {
            this.rec = data.payload
            delete this.rec.tekiyoStartYmd
            delete this.rec.tekiyoEndYmd

            // パスワードは削除する
            delete this.rec.etcRiyoshaPassword

            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msyssystemconfig'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.rec = {
              etcRiyoshaLoginId: '',
              etcRiyoshaPassword: '',
              memo: '',
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01'
            }
            resolve()
          })
        },
        savedInputRestorePromise: function () {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            resolve()
          })
        },
        existsIdMethod: function () {
          console.log('existsIdMethod', self.id)
          return self.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstEtcRiyouJoho/delete?id=${self.id}&tm=${self.rec.timestamp}`).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
          console.log('clear id', this.rec)
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            this.id = id
            this.transition(1, { id: id }, this.initialize)
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/MstEtcRiyouJoho/create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MstEtcRiyouJoho/update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        return false
      }
      return true
    },
    deleteValidate: function () {
      return true
    }
  }
}
